<template>
  <div class="row g-3">
    <template v-if="isLoading">
      <div v-for="n in 5" :key="'skeleton-' + n" class="col-md-4 col-sm-6">
        <div class="card placeholder-glow">
          <div class="card-img-top placeholder" style="height: 180px"></div>
          <div class="card-body">
            <h5 class="card-title placeholder col-6"></h5>
            <p class="card-text placeholder col-4"></p>
            <p class="card-text placeholder col-5"></p>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div
        v-for="template in templates"
        :key="template.id"
        class="col-xxl-2 col-xl-3 col-lg-4 col-md-6 col-sm-6"
      >
        <div class="card h-100 p-3 shadow-sm">
          <h5 class="card-title">#{{ template.id }} {{ template.name }}</h5>
          <img
            :src="getThumbnailUrl(template.img_screen)"
            class="card-img-top p-3"
            :alt="template.name"
            style="
              height: 180px;
              width: 100%;
              object-fit: contain;
              background: #f8f9fa;
              cursor: pointer;
            "
            @click="$emit('view', template)"
          />

          <div class="card-body d-flex flex-column justify-content-between">
            <div class="d-flex justify-content-between">
              <span class="card-text">
                <i class="bi bi-calendar"></i>
                {{ new Date(template.date).toLocaleDateString() }}
              </span>
              <span class="card-text">
                <i class="bi bi-printer"></i> {{ template.printer_type }}
              </span>
              <span class="card-text">
                <i class="bi bi-pc-display"></i>
                {{ template.active_devices_count }}
              </span>
            </div>

            <div class="d-flex justify-content-between align-items-center mt-3">
              <div></div>
              <div class="d-flex gap-2">
                <a
                  class="btn btn-sm btn-outline-secondary"
                  :href="this.getEditorUrl(template.id)" 
                  :target="'edit_template'+template.id"
                  title="Edit"
                >
                  <i class="bi bi-pencil"></i>
                </a>
                
                <button
                  class="btn btn-sm btn-outline-secondary"
                  @click="$emit('copy', template)"
                  title="Copy"
                >
                  <i class="bi bi-copy"></i>
                </button>
                
                <button
                  class="btn btn-sm btn-outline-secondary"
                  @click="$emit('delete', template)"
                  title="Delete"
                >
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    templates: {
      type: Array,
      required: true,
    },
    isLoading: Boolean,
    searchQuery: {
      type: String,
      default: "",
    },
    getEditorUrl: Function
  },
  methods: {
    getThumbnailUrl(path) {
      return process.env.VUE_APP_TEMPLATE_THUMBNAIL_URL + path;
    },
  },
};
</script>

<style scoped>
.card-title {
  font-weight: bold;
  font-size: 1.1rem;
}

.status-badge {
  padding: 6px 10px;
  font-size: 0.85rem;
  font-weight: bold;
  border-radius: 12px;
  min-width: 80px;
  text-align: center;
}

.placeholder {
  background: #dee2e6;
  border-radius: 4px;
}
</style>